import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { ImportProcessDialog } from "../Ui/Dialogs/ImportProcessDialog";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandProcessImportPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandProcessImportProperties = {
    [name in keyof EntityCommandProcessImportPropertyValues]: Property<EntityCommandProcessImportPropertyValues[name]>
};

export interface IEntityCommandProcessImport extends IEntityCommand, EntityCommandProcessImportProperties
{
}

export class EntityCommandProcessImport extends EntityCommand implements IEntityCommandProcessImport
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandProcessImport";
    public static override className = "EntityCommandProcessImport";

    // #region Global Variables

    private static importProcessDialog: ImportProcessDialog;

    // #endregion

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandProcessImportPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Import",
                entityName: "Process",
                key: "IMPORT",
                permission: PermissionEvaluator.permissionLevels.execute,
                type: EntityCommandTypeEnum.entitySet,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandProcessImportPropertyValues>)
    {
        super(propertyValues);

        if (!EntityCommandProcessImport.importProcessDialog)
            EntityCommandProcessImport.importProcessDialog = new ImportProcessDialog();
    }

    // #endregion

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    return (
                        EntityCommandProcessImport.importProcessDialog
                            .openAsync()
                    );
                })
        );
    }

    // #endregion

    // #endregion
}

